"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ElipsisItem = exports.ElipsisItemElipse = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var ElipsisItemElipse = _styledComponents["default"].span.withConfig({
  displayName: "ElipsisItemstyles__ElipsisItemElipse",
  componentId: "sc-p91ciq-0"
})(["align-items:center;border-radius:", ";box-sizing:border-box;color:", ";display:flex;", ";font-weight:bold;height:", ";justify-content:center;line-height:", ";min-width:", ";padding:0 ", ";text-align:center;vertical-align:top;"], _tokens["default"].borderRadius, _tokens["default"].color.blackLighten20, _stylers["default"].fontSize(-1), _stylers["default"].spacer(3), _stylers["default"].spacer(3), _stylers["default"].spacer(3), _tokens["default"].spaceSm);

exports.ElipsisItemElipse = ElipsisItemElipse;

var ElipsisItem = _styledComponents["default"].span.withConfig({
  displayName: "ElipsisItemstyles__ElipsisItem",
  componentId: "sc-p91ciq-1"
})(["align-items:center;border-radius:", ";box-sizing:border-box;display:flex;height:", ";justify-content:center;margin:0 ", " 0 ", ";position:relative;"], _tokens["default"].borderRadius, _stylers["default"].spacer(3), _tokens["default"].spaceSm + 1, _tokens["default"].spaceSm);

exports.ElipsisItem = ElipsisItem;
//# sourceMappingURL=ElipsisItem.styles.js.map